module.exports = __webpack_public_path__ + "static/media/laptop-pencil-mob.113dac73.jpg";